import { render, staticRenderFns } from "./add-offline-activity.vue?vue&type=template&id=15fa798d&scoped=true&"
import script from "./add-offline-activity.vue?vue&type=script&lang=js&"
export * from "./add-offline-activity.vue?vue&type=script&lang=js&"
import style0 from "./add-offline-activity.vue?vue&type=style&index=0&id=15fa798d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fa798d",
  null
  
)

export default component.exports